import './SearchBar.scss'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { saveInputLocation, savePhysicalStores } from '../redux/reducers/popupDataSlice';
import { useState } from 'react'
import { fetchPhysicalStores } from '../rest/physicalStores';
import { INVALID_REQUEST, OK, ZERO_RESULTS } from '../utils/geocoder-status';

const SearchBar = props => {

    const { t } = useTranslation();

    const storeDispatcher = useDispatch();
   
    const [inputLocation, setInputLocation] = useState('');
    const [noStore, setNoStore] = useState('');

    let [lat, lng] = [];

    const getPosition= () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    lng = position.coords.longitude;
                    lat = position.coords.latitude;

                    storeDispatcher(saveInputLocation(''));
                    getStores(lat, lng); // TODO pass lat and lng to getStores()
                });
        }
    };


    const findStores = (e) => {
        e.preventDefault();
        if (!inputLocation || inputLocation === '') {
            // TODO add validation alert 
            console.log('Enter a valid location');
        }
        else {
            getLatAndLng(inputLocation);
        }
    }

    const getLatAndLng = (input) => {
        if(props.config.storeId == 10852){
            input = input+ ', Canada'
        }else{
            input = input+ ', USA'
        }
        var Geocoder;
        Geocoder = new window.google.maps.Geocoder();      
        Geocoder.geocode({ address: input }, (response, status) => {
            if (status === OK && response.length > 0) {
                lng = response[0].geometry.location.lng();
                lat = response[0].geometry.location.lat();
                console.log('LNG, LAT: ', lng, lat);
                // if input location returns valid lat and lng values save it to redux store
                storeDispatcher(saveInputLocation(inputLocation));
                // and fetch stores
                getStores(lat, lng); // TODO pass lat and lng to getStores()
            } else if (status === ZERO_RESULTS) {
                // TODO alert
                console.log('No results for the requested location');
            } else if (status === INVALID_REQUEST) {
                // TODO alert
            } else {
                // TODO alert
            }

        });
    }

    const getStores = (lat, lng) => {
        fetchPhysicalStores(props.config, lat, lng).then(function (response) {
            let stores;
            if (response) {
                stores = response.PhysicalStore;
                if (stores === undefined) {
                    setNoStore(true);
                }
                storeDispatcher(savePhysicalStores(stores));
            } else {
                setNoStore(true);
            }
            return stores;
        })
        .catch(function (err) {
            console.error(err.statusText);
            setNoStore(true);
        })

    }

    const onChangeSearchBar = e => {
        setInputLocation(e.target.value);
        setNoStore(false);
    };

    let searchBarPlaceholder = '';

    if (props.config.storeId == 10851) searchBarPlaceholder = 'search-bar-placeholder';
    if (props.config.storeId == 10852) searchBarPlaceholder = 'search-bar-placeholder-ca';

    return (
        <div className='search-bar container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <label className='search-label' htmlFor='search-input'> {t('search-bar-label')}</label>
                </div>
            </div>

            <div className='search-bar-container row'>
                <input id='search-input'
                    className='search-input'
                    placeholder={t(searchBarPlaceholder)}
                    value={inputLocation}
                    onChange={(e) => onChangeSearchBar(e)}
                ></input>
                 <svg className="gps-nav" onClick={() => getPosition()}>
                    <use xlinkHref='#gps-nav'/>
                 </svg>
                <button className='search-bar-btn' data-element-id='X_Pdp_FindStoreOverlay_CheckAvail' onClick={(e) => findStores(e)}>{t('search-bar-button')}</button>
            </div>
            {noStore && (
                <div className='no-store-found row'>
                    <span>{t('no-store-found')}</span>
                </div>
            )}
           
        </div>
    )
}

export default SearchBar



